import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    continue: 'Continue',
    documentName: 'Mandate',
  },
  fr: {
    continue: 'Continuer',
    documentName: 'Mandat',
  },
} as const);
